import React, { useState } from 'react';
import { QuillEditor } from '../../../../components/common/quill-editor/quill-editor';
import { FieldLabel } from '@measured/puck';
import CustomTooltip from '../../../../components/common/tooltip';
import { Delete, ExpandMore, ExpandLess } from '@mui/icons-material';
import { Switch, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

export interface FooterArrayFieldsProps {
  content: {
    viewMoreTerms: boolean;
    contentValue: string;
    popUpContent: string;
  };
}
interface IProps {
  value: FooterArrayFieldsProps[];
  onChange: (_value: FooterArrayFieldsProps[]) => void;
}

const FooterArrayFields = ({ value, onChange }: IProps) => {
  const clonedValue = structuredClone(value) as FooterArrayFieldsProps[];
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const toggleExpand = (index: number) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const removeFooter = (index: number) => {
    const updatedContent = [...clonedValue];
    updatedContent.splice(index, 1);
    onChange(updatedContent);
    if (expandedIndex === index) setExpandedIndex(null);
  };
  return (
    <FieldLabel
      label={
        (
          <CustomTooltip title="Text">
            <span>Footer Text</span>
          </CustomTooltip>
        ) as React.ReactNode as string
      }
      className="border p-2 border-gray-700"
      el="div">
      <>
        {clonedValue?.map((footer, index) => (
          <div key={index} className="p-2 border border-gray-700">
            <div
              className="flex items-center justify-between p-2 hover:bg-gray-700 cursor-pointer"
              onClick={() => toggleExpand(index)}>
              <span>{'Footer ' + (index + 1)}</span>
              <div className="flex gap-2">
                <Delete
                  className="w-4 h-4 text-gray-400 hover:text-red-500 cursor-pointer"
                  onClick={e => {
                    e.stopPropagation();
                    removeFooter(index);
                  }}
                />
                {expandedIndex === index ? (
                  <ExpandMore className="w-4 h-4 text-gray-400" />
                ) : (
                  <ExpandLess className="w-4 h-4 text-gray-400" />
                )}
              </div>
            </div>
            {expandedIndex === index && (
              <div className="p-2 flex justify-between items-center">
                <div key={index}>
                  <QuillEditor
                    value={footer?.content?.contentValue}
                    onChange={val => {
                      // Create a DOM parser to parse the string into a DOM object
                      const parser = new DOMParser();
                      const doc = parser.parseFromString(val, 'text/html');

                      // Find all <a> tags
                      const anchorTags = doc.querySelectorAll('a');

                      // Loop through each <a> tag and modify the style if needed
                      anchorTags.forEach(anchor => {
                        const style = anchor.getAttribute('style');
                        if (!style || !style.includes('color')) {
                          anchor.style.color = 'black'; // Apply default black color if missing
                        }
                      });
                      const updatedContent = [...clonedValue];
                      updatedContent[index].content.contentValue =
                        doc.body.innerHTML;
                      onChange(updatedContent);
                    }}
                    id={index + 1}
                  />
                  <div className="grid mt-2 overflow-hidden pop-up-array-field-footer">
                    <div className="flex justify-between items-center mb-3 pop-up-array-field-footer ">
                      <p className="text-sm font-semibold"> Show Pop Up</p>
                      <div className="flex gap-0.5 items-center">
                        <Tooltip
                          title={`Extra terms will be displayed when user clicks on "Learn More"`}
                          placement="top-start">
                          <InfoIcon fontSize="small" className="h-1 w-1" />
                        </Tooltip>
                        <Switch
                          className="disable-page-builder-theme"
                          checked={footer?.content?.viewMoreTerms}
                          onChange={val => {
                            console.log('val', val.target.checked);

                            const updatedContent = [...clonedValue];
                            updatedContent[index].content.viewMoreTerms =
                              val.target.checked;
                            onChange(updatedContent);
                          }}
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      </div>
                    </div>
                  </div>
                  {footer?.content?.viewMoreTerms && (
                    <QuillEditor
                      value={footer?.content?.popUpContent}
                      onChange={val => {
                        const updatedContent = [...clonedValue];
                        updatedContent[index].content.popUpContent = val;
                        onChange(updatedContent);
                      }}
                      id={index + 2}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        ))}
        <button
          className="w-full p-2 text-center text-gray-400 hover:text-white hover:bg-gray-700 border border-gray-700"
          onClick={() =>
            onChange([
              ...clonedValue,
              {
                content: {
                  viewMoreTerms: false,
                  contentValue: '',
                  popUpContent: '',
                },
              },
            ])
          }>
          +
        </button>
      </>
    </FieldLabel>
  );
};

export default FooterArrayFields;
